import { Component, OnInit , Input } from '@angular/core';

@Component({
  selector: 'app-printradio',
  templateUrl: './printradio.component.html',
  styleUrls: ['./printradio.component.scss'],
})
export class PrintradioComponent implements OnInit {

  @Input() quest1: any;
  
  tabQuest = [];
  resultat:number;

  constructor() { }

  ngOnInit() {}

  ngOnChanges() { 
    //alert(JSON.stringify(this.url));
    
    let lgTab = Object.keys(this.quest1).length;
    //let lgTab = this.tabQuest[this.posiquest].length;
    //alert(lgTab);
    //let tab1 : any; 
    //alert(JSON.stringify(tabPage));
    
    this.resultat = this.quest1[0]["res"];
    
    for (let i = 0; i < lgTab; i++) {
        
        if(this.quest1[i]["sol"]&&this.quest1[i]["rep"]) {
            this.tabQuest.push({
            //  id: i,
              key: "labelv",
              value: this.quest1[i]["label"]
            });
        } else if(this.quest1[i]["sol"]) {
          this.tabQuest.push({
          //  id: i,
            key: "label",
            value: this.quest1[i]["label"]
          });
       } else if(this.quest1[i]["rep"]) {
        this.tabQuest.push({
        //  id: i,
          key: "labelf",
          value: this.quest1[i]["label"]
        });
      }
        
    }//fin for

    //alert(JSON.stringify(this.tabQuest));

   
  }

}
